// @flow
import type { CurrentUser } from 'api/currentUser';
import { getItem } from 'utils/localStorage';

export const isStaff = (user: CurrentUser) =>
  user && user.permissions && user.permissions.includes('staff');

export const isLoggedIn = (user?: CurrentUser) => user && user.id;

export const isNonAdmin = (user: CurrentUser) =>
  Boolean(
    user &&
      user.id &&
      user.permissions &&
      !['staff', 'orgAdmin'].some(permission =>
        user.permissions.includes(permission)
      )
  );

export const isLocationInCountry = (user: CurrentUser, countryCode: string) =>
  user && user.location && user.location.countryCode === countryCode;

export const isSalarySurveyCompleted = (user: CurrentUser) => {
  if (user && user.id) {
    return Boolean(user.salarySurvey && user.salarySurvey.lastSubmitted);
  }

  return Boolean(getItem('salarySurveyLastSubmitted'));
};

export const salarySurveyLastSubmittedDate = (user: CurrentUser) => {
  if (user && user.id) {
    return user.salarySurvey && user.salarySurvey.lastSubmitted;
  }

  const localStorageLastSubmitted = getItem('salarySurveyLastSubmitted');
  if (Array.isArray(localStorageLastSubmitted)) {
    return localStorageLastSubmitted[0];
  }
  return null;
};
